<template>

  <section class="content">

    <modal title="Supprimer un secteur"
           v-on:close="doCloseAnyModals"
           v-if="deleteModal === true">
      <secteurs-delete slot="body"
                       v-on:close="doCloseAnyModals"
                       :secteur="secteur"></secteurs-delete>
    </modal>

    <modal title="Modifier un secteur"
           v-on:close="doCloseAnyModals"
           v-if="updateModal === true">
      <secteurs-form slot="body"
                     v-on:close="doCloseAnyModals"
                     :update-secteur="secteur"></secteurs-form>
    </modal>

    <modal title="Ajouter un secteur"
           v-on:close="doCloseAnyModals"
           v-if="createModal === true">
      <secteurs-form slot="body"
                     v-on:close="doCloseAnyModals"></secteurs-form>
    </modal>

    <section class="content-toolbar">
      <div class="btn btn-primary"
           v-on:click="clickCreate()">Ajouter un secteur</div>
    </section>

    <secteurs-list v-on:delete="clickDelete"
                   v-on:edit="clickEdit">
    </secteurs-list>

  </section>
  
</template>

<script>
import SecteursList from './SecteursList'
import SecteursDelete from './SecteursDelete'
import SecteursForm from './SecteursForm'
import Modal from '../commons/Modal'

export default {
  components: {
    SecteursList,
    SecteursDelete,
    SecteursForm,
    Modal,
  },
  data: function () {
    return {
      deleteModal: false,
      updateModal: false,
      createModal: false,
      secteur: null,
    }
  },
  methods: {
    clickDelete: function (secteur) {
      this.secteur = secteur
      this.deleteModal = true
    },
    clickEdit: function (secteur) {
      this.secteur = secteur
      this.updateModal = true
    },
    clickCreate: function () {
      this.createModal = true
    },
    doCloseAnyModals: function () {
      this.deleteModal = false
      this.updateModal = false
      this.createModal = false
    },
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Secteurs.vue?e7ba9a3a